import React from "react";
import OrderList from "../orderList/OrderList";

interface IOrdersProps {

}

const Orders = (props:IOrdersProps) => {

    return (
        <div className="w-full  h-full">
            <div className="gap-4 grid h-full w-full">
    
                <div className="bg-gray h-full">
                    <div className="mx-auto max-w-screen-2xl h-full">
                        {/* <div className="container w-full">
                            
                        </div> */}
                            {/* <div className="w-full relative flex flex-col sm:flex-row sm:min-h-[62vh] gap-4"> */}
                                {/* <div className="relative block">
                                    

                                    <Filter
                                        facets={facets}
                                        // facets={facets}
                                        sort="default"
                                        changeFilter={onChangeFilter}
                                        // changeOptions={onOptionsChange}
                                        // className='w-full sm:w-[200px]'
                                        // changeSort={onChangeSort}
                                    />


                                </div> */}
                                <div className="w-full">
                                    <OrderList />
                                </div>

                            {/* </div> */}
                    </div>
                </div>
            </div>
           
        </div>
    )
};

export default Orders;
